<template>
    <div class="DeviceStatus" >
        <Title firstName="暖通设备控制" lastName="HVAC EQUIPMENT CONTROL" />
        <!-- <div class="selectMonitor selectMonitor1" @click="ishow=!ishow">
            {{currentName}}
            <i class="el-icon-arrow-down"></i>
            <div class="list" v-if="ishow">
                <SelectList :selectList="selectList" @tabTitle="tabTitle" keyk="id" keyval="name"/>
            </div>
        </div> -->
        <div class="echarts">
            <div class="content">
                <div class="title" >
                    {{getBuildId?$store.state.Cang.buildTree.find(item => item.id == getBuildId).name:'--'}}
                    <i class="el-icon-s-tools"></i>
                    <div class="selectMonitor" v-show="getFloorId">
                        <div class="tagname">
                            {{getFloorId}}
                            <!-- <i class="el-icon-caret-bottom"></i> -->
                        </div>
                        <!-- <div class="list" v-if="tagishow">
                            <SelectList :selectList="tagList" @tabTitle="tabTitletag" keyk="id" keyval="name"/>
                        </div> -->
                    </div>
                </div>
                <div class="table" >
                    <el-scrollbar style="height: 100%">
                    <table>
                        <tr>
                            <th>设备编号</th>
                            <th>设定温度</th>
                            <th>回风温度</th>
                            <th>状态</th>
                            <th>是否强制</th>
                        </tr>
                        <tr>
                            <td>1FGA_1</td>
                            <td>25℃</td>
                            <td>17℃</td>
                            <td>运行</td>
                            <td>非强制</td>
                        </tr>
                        <tr>
                            <td>1FGA_2</td>
                            <td>24℃</td>
                            <td>16℃</td>
                            <td>运行</td>
                            <td>非强制</td>
                        </tr>
                        <tr>
                            <td>1FGA_3</td>
                            <td>25℃</td>
                            <td>20℃</td>
                            <td>运行</td>
                            <td>非强制</td>
                        </tr>
                        <tr>
                            <td>1FGA_4</td>
                            <td>28℃</td>
                            <td>23℃</td>
                            <td>运行</td>
                            <td>非强制</td>
                        </tr>
                        <tr>
                            <td>1FGA_5</td>
                            <td>25℃</td>
                            <td>26℃</td>
                            <td>运行</td>
                            <td>非强制</td>
                        </tr>
                        <tr>
                            <td>1FGA_6</td>
                            <td>27℃</td>
                            <td>26℃</td>
                            <td>运行</td>
                            <td>非强制</td>
                        </tr>
                        <tr>
                            <td>1FGA_7</td>
                            <td>25℃</td>
                            <td>19℃</td>
                            <td>运行</td>
                            <td>非强制</td>
                        </tr>
                    </table>
                    </el-scrollbar>
                </div>
                

            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const SelectList = () => import('../../../../components/title/selectList.vue')
export default {
    inject:['buildId', 'floorId'],
    data(){
        return {
            tagname:"1F",
            tagishow:false,
            ishow:false,
            tagList:[
                {
                    id:1,
                    name:'1F'
                },
                {
                    id:2,
                    name:'2F'
                },
            ],
            currentName:"切换楼栋",
            selectList:[
                {
                    id:1,
                    name:'楼栋1'
                },
                {
                    id:2,
                    name:'楼栋2'
                },
                {
                    id:3,
                    name:'楼栋3'
                },
            ],
            buildName:'--',
        }
    },
    components:{
        Title,Graph,charts,SelectList
    },
    computed:{
		getBuildId(){
			return this.buildId()
		},
		getFloorId(){
			return this.floorId()
		},
	},
    watch:{
    },
    mounted(){
    
    },
    methods:{
        tabTitle(item){
            this.currentName = item.name
        },
        tabTitletag(item){
            this.tagname = item.name
        },
    },
    watch:{
        
    },
}
</script>

<style lang="less" scoped>
    .DeviceStatus{
        // height: 33.3vh;
        width: 20vw;
        // height: 493rem;
        position: fixed;
        top: 7.4vh;
        right: 1vw;
        z-index: 1;
        .selectMonitor1{
            position: absolute;
            top: 6rem;
            right: auto;
            left: 12vw;
            color: rgba(255, 255, 255, 0.7);
            z-index: 999;
            cursor: pointer;
            .list{
                right: auto;
                left: -12px;
                width: 100rpx;
                text-align: center;
                /deep/ .every{
                    padding-left: 3rem;
                }
            }
        }
        .echarts{
            position: relative;
            height: 24.5vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
            color: rgba(255, 255, 255, 0.7);
            
            .selectMonitor{
                text-align: right;
                margin-right:10rem;
                color: #E6F3FD ;
                cursor: pointer;
                position: relative;
                z-index: 99;
                margin-right: 1.5vw;
                float: right;
                .tagname{
                    border: 1px solid rgba(255, 255, 255, 0.5);
                    border-radius: 2rem;
                    display: inline-block;
                    width: 100rem;
                    height: 2vh;
                    line-height: 2vh;
                    text-align: center;
                }
                .list{
                    position: absolute;
                    right: 0;
                    width: 100%;
                    top: 100%;
                    text-align: left;
                    max-height: 15vh;
                }
            }
            .title{
                font-size: 16rem;
                height: 32rem;
                i{
                    float: right;
                    margin-top: 5rem;
                    font-size: 20rem;
                    cursor: pointer;
                }
            }
            .content{
                padding: 15rem ;
            }
            /deep/ .el-scrollbar__wrap {
                overflow-x: hidden;
            }
            /deep/ .el-scrollbar__bar.is-vertical {
                opacity: 1;
            }
            .table{
                font-size: 14rem;
                // overflow: auto;
                height: 190rem;
                table{
                    width: 100%;
                    text-align:center;
                    border-collapse:collapse;
                    th{
                        height: 32rem;
                        background: rgba(13, 148, 255, 0.3);
                    }
                    tr:nth-child(even) td{
                        background: rgba(13, 148, 255, 0.15);
                    }
                    td{
                        height: 32rem;
                        
                    }
                }
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>